import React from 'react'

const GrandOpening = () => {
  return (
    <div className='hidden md:block bg-[#1b1b1b] text-white text-center text-[16px] px-4 md:text-[18px] font-medium py-[18px] mb-4'>
      <strong>SOFT LAUNCH DEAL: </strong> from Sept 01 to Dec 30
    </div>
  )
}

export default GrandOpening